import { Link } from "react-router-dom";
import { SEO } from "../components/common/SEO";
import { useLanguage } from "../context/LanguageProvider";
import { pick, UI_STRINGS } from "../lib/i18n";

export default function NotFound() {
    const { lang } = useLanguage();
    return (
        <div
            data-testid="page-not-found"
            className="bg-ink min-h-[60vh] flex items-center"
        >
            <SEO
                title={`404 — ${pick(UI_STRINGS.misc.page_not_found, lang)}`}
                description={pick(UI_STRINGS.misc.page_not_found_body, lang)}
                lang={lang}
            />
            <div className="mx-auto max-w-2xl px-5 py-20 text-center">
                <div className="font-serif text-8xl text-gold">404</div>
                <div className="mt-4 font-serif text-2xl text-neutral-50">
                    {pick(UI_STRINGS.misc.page_not_found, lang)}
                </div>
                <p className="mt-3 text-neutral-400">
                    {pick(UI_STRINGS.misc.page_not_found_body, lang)}
                </p>
                <Link
                    to="/"
                    className="btn-gold mt-8 inline-flex"
                    data-testid="notfound-home"
                >
                    {pick(UI_STRINGS.misc.go_home, lang)}
                </Link>
            </div>
        </div>
    );
}
